import React from 'react'

const NoEvents = () => {
    return (
        <h3 style={{ marginTop: "20px", color: "#2f3835" }}> <center><b> No upcoming events for this location, stay tuned for more updates!</b></center></h3>
    )
}

export default NoEvents;